export function obterListaTipoVeiculo() {
  return (
    [
      { label: '02 - Ciclomotor', value: 'CICLOMOTOR' },
      { label: '03 - Motoneta', value: 'MOTONETA' },
      { label: '04 - Motocicleta', value: 'MOTOCICLETA' },
      { label: '05 - Triciclo', value: 'TRICICLO' },
      { label: '06 - Automóvel', value: 'AUTOMOVEL' },
      { label: '07 - Micro-ônibus', value: 'MICROONIBUE' },
      { label: '08 - Ônibus', value: 'ONIBUS' },
      { label: '10 - Reboque', value: 'REBOQUE' },
      { label: '11 - Semirreboque', value: 'SEMIRREBOQUE' },
      { label: '13 - Camioneta', value: 'CAMIONETA' },
      { label: '14 - Caminhão', value: 'CAMINHAO' },
      { label: '17 - Caminhão Trator', value: 'CAMINHAOTRATOR' },
      { label: '21 - Quadriciclo', value: 'QUADRICICLO' },
      { label: '23 - Caminhonete', value: 'CAMINHONETE' },
      { label: '25 - Utilitário', value: 'UTILITARIO' },
    ]
  );
}
